export enum _ScheduleTypeGeneric {
  GPS = 'GPS',
  VHF = 'VHF',
  COMMUNICATION = 'COMMUNICATION',
  PROXIMITY = 'PROXIMITY',
  EXTERNAL_SENSOR_RECEIVER = 'EXTERNAL_SENSOR_RECEIVER',
  VIRTUAL_FENCE = 'VIRTUAL_FENCE',
  CAMERA = 'CAMERA',
  HIGH_ACTIVITY_GPS = 'HIGH_ACTIVITY_GPS',
  SOLEX_GPS = 'SOLEX_GPS',
}
